module.exports = __webpack_public_path__ + "img/mizutamari-cut-01.0da1f695.jpg";